import GlobalNavAvatar from '@assets/global_nav_avatar.svg';
import AuthModule from '@modules/AuthModule';
import useAuth from '@modules/AuthModule/hooks/useAuth';
import { useDiagnostics } from '@modules/DiagnosticsModule/DiagnosticsContext';
import useService from '@modules/ServiceModule/useService';
import { ActionMenu, Tooltip } from '@servicetitan/design-system';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { ActivityDot, StyledButton, UserName } from './UserMenu.styled';
import UserStatusModule from '@modules/UserStatusModule';
import { UserSetAvailabilityStatus } from '@api/generated/graphql';
import DiagnosticsModule from '@modules/DiagnosticsModule';
import { useBugReportContext } from '@components/BugReportProvider/useBugReportContext';

export function UserMenu() {
  const service = useService();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const { errors } = useDiagnostics();
  const navigate = useNavigate();
  const { createBugReport } = useBugReportContext();

  const handleNavigate = () => {
    setOpen(false);
  };

  const handleSignout = async () => {
    setOpen(false);
    if (user && service.agentAvailable) {
      await UserStatusModule.setUserStatus(
        user.id,
        UserSetAvailabilityStatus.Offline,
      );
    }
    await AuthModule.signout();
    navigate('/');
  };

  const handleShowDiagnostics = () => {
    DiagnosticsModule.setDiagnosticsDrawerOpen(true);
  };

  const handleBugReport = () => {
    createBugReport();
  };

  if (!service) {
    return null;
  }

  const unreadErrors = errors.filter((error) => !error.read);

  return (
    <ActionMenu
      el='span'
      open={open}
      trigger={
        <Tooltip el='div' text='User Settings'>
          <StyledButton
            className='c-white'
            fill='subtle'
            iconName='keyboard_arrow_down'
            iconPosition='right'
            onClick={() => setOpen(!open)}
            size='xsmall'
          >
            <GlobalNavAvatar />
          </StyledButton>
        </Tooltip>
      }
      onClickOutside={() => setOpen(false)}
      data-testid='user-menu'
    >
      <ActionMenu.Group>
        <Link to='/profile'>
          <ActionMenu.Item onClick={handleNavigate}>Profile...</ActionMenu.Item>
        </Link>
        <ActionMenu.Item onClick={handleShowDiagnostics}>
          <>
            Diagnostics...
            <ActivityDot $errors={unreadErrors.length > 0} />
          </>
        </ActionMenu.Item>
      </ActionMenu.Group>
      <ActionMenu.Group>
        <ActionMenu.Item data-testid='bug-report' onClick={handleBugReport}>
          Report a bug...
        </ActionMenu.Item>
      </ActionMenu.Group>
      <ActionMenu.Group>
        <ActionMenu.Item data-testid='sign-out' onClick={handleSignout}>
          Sign Out <UserName>{user?.name}</UserName>
        </ActionMenu.Item>
      </ActionMenu.Group>
    </ActionMenu>
  );
}

export default UserMenu;
